import { useEffect, useState } from "react";
import { FaSearch, FaRegFileAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { getAccessToken } from "../../storage/storage";
import axios from "axios";
import { OtherTaskSkeleton } from "../../components/Skeletons";
import { FormatDate } from "../../utils/FormateDate";

export default function OtherTask() {
  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const Navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/api/properties/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setOptions(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setLoading(false);
      });
  }, []);

  const handleTaskSheetClick = (id) => {
    Navigate(`/other-tasksheets/${id}`);
  };

  const handleInvoiceClick = (guestStayId) => {
    Navigate(`/task-invoice/${guestStayId}`);
  };

  return (
    <div className="flex lg:flex-row flex-col lg:items-start items-center px-4 w-full h-full">
      <div className="lg:px-10 px-4 mt-8 mb-16 h-[100vh] w-full">
        <h1 className="md:text-3xl text-lg font-bold text-[#586989] mb-8">
          Property Invoices & Task Sheets{" "}
        </h1>
        <div className="relative mt-4 pb-5">
          <div className="border border-[#DFDFDF] bg-white rounded-lg shadow-md overflow-auto max-h-[70vh] w-full">
            <table className="w-full border-collapse min-w-[600px]">
              <thead className="sticky top-0 bg-[#FFF5CE] text-[#586989] z-10">
                <tr>
                  <th className="p-4 text-center min-w-[150px]">
                    Property Name
                  </th>

                  <th className="py-3 px-4 min-w-[150px] text-center">
                    Address
                  </th>
                  {/* <th className="py-3 px-4 min-w-[150px] text-center">
                    Action Date
                  </th> */}
                  <th className="p-2 text-center min-w-[150px]">Invoice</th>
                  <th className="p-2 text-center min-w-[150px]">Task Sheet</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <OtherTaskSkeleton />
                ) : options?.length > 0 ? (
                  options?.map((stay, index) => (
                    <tr key={index} className="border-b">
                      <td className="px-4 py-6 text-center">{stay.name}</td>
                      <td className="px-4 py-6 text-center">
                        {stay.address_line1}
                        {stay.city}
                        {stay.country}
                      </td>
                      {/* <td className="px-4 py-6 text-center">
                        {FormatDate(stay.created_at)}
                      </td> */}
                      <td className="p-2 text-green-700 text-center whitespace-nowrap">
                        <div className="flex items-center justify-center">
                          <span
                            onClick={() => handleInvoiceClick(stay.id)}
                            className="cursor-pointer flex items-center gap-1"
                          >
                            <FaRegFileAlt /> View Invoices
                          </span>
                        </div>
                      </td>
                      <td className="p-2 text-green-700 text-center whitespace-nowrap">
                        <div className="flex items-center justify-center">
                          <span
                            onClick={() => handleTaskSheetClick(stay.id)}
                            className="cursor-pointer flex items-center gap-1"
                          >
                            <FaRegFileAlt /> View Task Sheets
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center text-lg font-bold text-[#586989] h-[400px]"
                    >
                      No Properties found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
